module.exports = __webpack_public_path__ + "static/media/xiaowu.795db62a.png";